var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8538 25.7008C11.1222 25.8574 11.2564 25.9357 11.4459 25.9764C11.5929 26.0079 11.8073 26.0079 11.9543 25.9764C12.1438 25.9357 12.278 25.8574 12.5464 25.7008C14.9085 24.3228 21.4002 19.9942 21.4002 14.0427V8.24395C21.4002 7.27454 21.4002 6.78983 21.2416 6.37317C21.1016 6.0051 20.874 5.67667 20.5785 5.41629C20.2441 5.12154 19.7902 4.95135 18.8825 4.61096L12.3813 2.17299C12.1292 2.07846 12.0032 2.0312 11.8735 2.01246C11.7585 1.99585 11.6417 1.99585 11.5267 2.01246C11.397 2.0312 11.271 2.07847 11.0189 2.17299L4.51767 4.61096C3.60997 4.95135 3.15612 5.12154 2.82167 5.41629C2.52621 5.67667 2.29861 6.0051 2.15855 6.37317C2 6.78983 2 7.27454 2 8.24395V14.0427C2 19.9942 8.49174 24.3228 10.8538 25.7008Z",
    fill: "#349999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9126 8.58623L9.27507 12.2238L14.1251 14.6488L10.4876 18.2863",
    fill: "#349999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9126 8.58623L9.27507 12.2238L14.1251 14.6488L10.4876 18.2863M21.4002 14.0427C21.4002 19.9942 14.9085 24.3228 12.5464 25.7008C12.278 25.8574 12.1438 25.9357 11.9543 25.9764C11.8073 26.0079 11.5929 26.0079 11.4459 25.9764C11.2564 25.9357 11.1222 25.8574 10.8538 25.7008C8.49174 24.3228 2 19.9942 2 14.0427V8.24395C2 7.27454 2 6.78983 2.15855 6.37317C2.29861 6.0051 2.52621 5.67667 2.82167 5.41629C3.15612 5.12154 3.60997 4.95135 4.51767 4.61096L11.0189 2.17299C11.271 2.07847 11.397 2.0312 11.5267 2.01246C11.6417 1.99585 11.7585 1.99585 11.8735 2.01246C12.0032 2.0312 12.1292 2.07846 12.3813 2.17299L18.8825 4.61096C19.7902 4.95135 20.2441 5.12154 20.5785 5.41629C20.874 5.67667 21.1016 6.0051 21.2416 6.37317C21.4002 6.78983 21.4002 7.27454 21.4002 8.24395V14.0427Z",
    stroke: "white",
    strokeWidth: 2.42502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.ccf38e66ccb829d6d44ae169ed0598c2.svg";
export { ForwardRef as ReactComponent };